import axios from "axios";
import { EmbeddingResponseApiModel } from "../../api-models";

export default async function getEmbedding(text: string): Promise<number[]> {
  return (
    await axios.post<EmbeddingResponseApiModel>(
      "/api/openaiembeddings",
      {
        model: "text-embedding-ada-002",
        input: [text],
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    )
  ).data.data.map((x) => x.embedding)[0];
}
